// extracted by mini-css-extract-plugin
module.exports = {"disabled":"groupsTable_disabled__25Aa6","section_header":"groupsTable_section_header__1mgFJ","table_container":"groupsTable_table_container__194Ox"};